import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/vedratan95/" className="home__social-icon" target="_blank " rel="noreferrer">
            <i className="uil uil-instagram"></i>
        </a>

        <a href="https://www.linkedin.com/in/vedratan/" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class="uil uil-linkedin-alt"></i>
        </a>
        
        <a href="https://github.com/VedRatan" className="home__social-icon" target="_blank" rel="noreferrer">
        <i class="uil uil-github-alt"></i>
        </a>

    </div>
  )
}

export default Social